import type { ReactNode } from 'react';

import { cn } from '@muzly/lib/utils';

export type PillTone = 'pink' | 'mint' | 'orange' | 'gray';

/**
 * 알약 배지 — 시안의 등급 배지 네 가지 색. `좋음`=핑크, `보통`=민트, `주의`=주황,
 * 값이 없거나 중립이면 회색. 색은 뜻을 실으므로 호출부가 등급으로 고른다.
 */
const TONE: Record<PillTone, string> = {
  pink: 'bg-[rgba(255,45,85,0.08)] text-pink',
  mint: 'bg-mint-soft text-mint',
  orange: 'bg-[rgba(255,149,0,0.12)] text-orange',
  gray: 'bg-bk-50 text-bk-600',
};

export const Pill = ({
  tone = 'gray',
  className,
  children,
}: {
  tone?: PillTone;
  className?: string;
  children: ReactNode;
}) => (
  <span
    className={cn(
      'inline-flex shrink-0 items-center rounded-full px-3 py-1.5 text-xs font-semibold tracking-[-0.06px] whitespace-nowrap',
      TONE[tone],
      className,
    )}
  >
    {children}
  </span>
);
